import { ReactNode } from "react";
import styled, { css } from "styled-components";
import { StyledText16, StyledText13 } from "styles/Text";
import { colors } from "constants/colors";
import TextInput, { Props as BaseProps } from "components/atoms/TextInput";
import { MarginStyleType } from "types/Common";

interface Props extends BaseProps {
  label: string; // 라벨 text
  labelSize?: number; // 라벨 size
  labelColor?: string; // 라벨 color
  subLabelText?: string; // 서브 라벨 text (label과 같은 줄)
  subLabelComponent?: ReactNode; // 서브 라벨 component (label 아래 줄)
  inputFontSize?: number;
  isRequiredMark?: boolean; // 필수 표시(*)
}

const TextInputAndLabel = ({
  id,
  label,
  labelSize,
  labelColor,
  subLabelText,
  subLabelComponent,
  inputFontSize,
  $marginTop,
  $marginLeft,
  $marginRight,
  $marginBottom,
  isRequiredMark,
  ...textInputProps
}: Props & MarginStyleType) => {
  return (
    <StyledContainer
      $marginTop={$marginTop}
      $marginLeft={$marginLeft}
      $marginRight={$marginRight}
      $marginBottom={$marginBottom}
    >
      <StyledLabelWrap>
        {labelSize === 13 ? (
          <StyledText13
            as="label"
            htmlFor={id}
            color={labelColor ? labelColor : colors.darkGray1}
          >
            {label}
            {isRequiredMark && (
              <StyledText13 color={colors.statusError}>*</StyledText13>
            )}
          </StyledText13>
        ) : (
          <StyledText16
            as="label"
            htmlFor={id}
            color={labelColor ? labelColor : colors.black}
          >
            {label}{" "}
            <StyledText13 color={colors.gray}>{subLabelText}</StyledText13>
          </StyledText16>
        )}
      </StyledLabelWrap>
      {subLabelComponent && (
        <StyledSubLabelWrap>{subLabelComponent}</StyledSubLabelWrap>
      )}
      <TextInput
        $marginTop={labelSize === 13 ? 8 : 12}
        inputFontSize={inputFontSize}
        id={id}
        {...textInputProps}
      />
    </StyledContainer>
  );
};
export default TextInputAndLabel;

const StyledContainer = styled.div<{
  $marginTop?: number;
  $marginRight?: number;
  $marginLeft?: number;
  $marginBottom?: number;
}>`
  flex-shrink: 1;
  ${({ $marginTop }) =>
    $marginTop &&
    css`
      margin-top: ${$marginTop}px;
    `}
  ${({ $marginRight }) =>
    $marginRight &&
    css`
      margin-right: ${$marginRight}px;
    `}
  ${({ $marginLeft }) =>
    $marginLeft &&
    css`
      margin-left: ${$marginLeft}px;
    `}
  ${({ $marginBottom }) =>
    $marginBottom &&
    css`
      margin-bottom: ${$marginBottom}px;
    `}
`;

const StyledLabelWrap = styled.div`
  margin-left: 4px;
`;

const StyledSubLabelWrap = styled.div`
  margin-left: 4px;
  margin-top: 4px;
`;
